import ForgotPasswordPage from '../src/features/Auth/containers/ForgotPasswordPage';

export default ForgotPasswordPage;
